module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row d-none"
  }, [(!_vm.pricePerOrder) ? _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Custom Group")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentGroupNameProp),
      expression: "currentGroupNameProp"
    }],
    staticClass: "w-100",
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "placeholder": "e.g: (> 2 years)"
    },
    domProps: {
      "value": (_vm.currentGroupNameProp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentGroupNameProp = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: {
      'min-height': _vm.pricePerPerson.genderPriceType === 2
    }
  }, [(!_vm.isCustomGenderPrice(_vm.pricePerPerson)) ? _c('div', {
    staticClass: "col-sm-3 pr-0"
  }, [_c('div', {
    staticClass: "d-flex w-100 justify-content-between"
  }, [(!_vm.pricePerOrder) ? _c('label', {
    staticClass: "full"
  }, [_vm._v("Price Category")]) : _vm._e()]), _vm._v(" "), (_vm.audienceTypes && !_vm.isCustomGenderPrice(_vm.pricePerPerson)) ? _c('v-select', {
    attrs: {
      "options": _vm.audienceTypes,
      "label": "description",
      "placeholder": "- Select type -",
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        return _vm.updateAudienceType(_vm.pricePerPerson, _vm.pricePerPerson.audienceTypeHelper)
      }
    },
    model: {
      value: (_vm.pricePerPerson.audienceTypeHelper),
      callback: function($$v) {
        _vm.$set(_vm.pricePerPerson, "audienceTypeHelper", $$v)
      },
      expression: "pricePerPerson.audienceTypeHelper"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCustomGenderPrice(_vm.pricePerPerson)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pricePerPerson.audienceTypeDescription),
      expression: "pricePerPerson.audienceTypeDescription"
    }],
    class: {
      'w-100': true,
      'error-field': _vm.pricePerPerson.isRepeated
    },
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.pricePerPerson.audienceTypeDescription)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pricePerPerson, "audienceTypeDescription", $event.target.value)
      }, function($event) {
        return _vm.emitCustomUpdate()
      }]
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isCustomGenderPrice(_vm.pricePerPerson)) ? _c('div', {
    staticClass: "col-sm-3 pr-0"
  }, [_c('div', {
    staticClass: "d-flex w-100 justify-content-between"
  }, [(!_vm.pricePerOrder) ? _c('label', {
    staticClass: "full"
  }, [_vm._v("Price Category")]) : _vm._e()]), _vm._v(" "), (_vm.isCustomGenderPrice(_vm.pricePerPerson)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pricePerPerson.audienceTypeDescription),
      expression: "pricePerPerson.audienceTypeDescription"
    }],
    class: {
      'w-100': true,
      'error-field': _vm.pricePerPerson.isRepeated
    },
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.pricePerPerson.audienceTypeDescription)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pricePerPerson, "audienceTypeDescription", $event.target.value)
      }, function($event) {
        return _vm.emitCustomUpdate(_vm.pricePerPerson)
      }]
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isCustomGenderPrice(_vm.pricePerPerson)) ? _c('div', {
    staticClass: "col-sm-4 pr-0"
  }, [_c('div', {
    staticClass: "d-flex w-100 justify-content-between"
  }, [(!_vm.pricePerOrder) ? _c('label', {
    staticClass: "full"
  }, [_vm._v("Category Association "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("*")])]) : _vm._e()]), _vm._v(" "), (_vm.isCustomGenderPrice(_vm.pricePerPerson)) ? _c('v-select', {
    class: {
      'error-field': _vm.isCustomPriceValid(_vm.pricePerPerson)
    },
    attrs: {
      "options": _vm.audienceTypesNoCustom,
      "label": "description",
      "placeholder": "- Select association -",
      "disabled": _vm.disabled,
      "clearable": true
    },
    on: {
      "input": function($event) {
        return _vm.updateCustomAudienceType(_vm.pricePerPerson, _vm.pricePerPerson.audienceTypeAssossiationHelper)
      }
    },
    model: {
      value: (_vm.pricePerPerson.audienceTypeAssossiationHelper),
      callback: function($$v) {
        _vm.$set(_vm.pricePerPerson, "audienceTypeAssossiationHelper", $$v)
      },
      expression: "pricePerPerson.audienceTypeAssossiationHelper"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showDelete && _vm.pricePerOrder) ? _c('div', {
    class: {
      'd-flex justify-content-end align-items-center': true,
      'col-sm-9': !_vm.isCustomGenderPrice(_vm.pricePerPerson),
      'col-sm-5': _vm.isCustomGenderPrice(_vm.pricePerPerson)
    }
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Remove'),
      expression: "'Remove'"
    }],
    staticClass: "ico-delete fs-large medium",
    class: {
      'pointer': !_vm.disabled,
      'notAllowed': _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.removePrincingAgeRow(_vm.pricePerPerson)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.pricePerOrder) ? _c('div', {
    staticClass: "col-sm-3 pr-0"
  }, [_c('div', {}, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Label")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pricePerPerson.audienceTypeLabel),
      expression: "pricePerPerson.audienceTypeLabel"
    }],
    staticClass: "w-100",
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "placeholder": "e.g: (> 2 years)"
    },
    domProps: {
      "value": (_vm.pricePerPerson.audienceTypeLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pricePerPerson, "audienceTypeLabel", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.pricePerOrder && !_vm.isCustomGenderPrice(_vm.pricePerPerson)) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Occupancy")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pricePerPerson.audienceTypeOccupancy),
      expression: "pricePerPerson.audienceTypeOccupancy"
    }],
    staticClass: "text-center",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "disabled": _vm.disabled || !_vm.isCustomGenderPrice(_vm.pricePerPerson),
      "type": "number",
      "placeholder": "1"
    },
    domProps: {
      "value": (_vm.pricePerPerson.audienceTypeOccupancy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pricePerPerson, "audienceTypeOccupancy", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.pricePerOrder && _vm.isCustomGenderPrice(_vm.pricePerPerson)) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Occupancy")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pricePerPerson.audienceTypeOccupancy),
      expression: "pricePerPerson.audienceTypeOccupancy"
    }],
    staticClass: "text-center",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.disabled || !_vm.isCustomGenderPrice(_vm.pricePerPerson),
      "type": "number",
      "placeholder": "1"
    },
    domProps: {
      "value": (_vm.pricePerPerson.audienceTypeOccupancy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pricePerPerson, "audienceTypeOccupancy", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column ml-3"
  }, [(_vm.pricePerPerson.isRepeated) ? _c('div', {
    staticClass: "error"
  }, [_c('span', [_vm._v("Custom name should be unique")])]) : _vm._e(), _vm._v(" "), (_vm.isCustomPriceValid(_vm.pricePerPerson)) ? _c('div', {
    staticClass: "error"
  }, [_c('span', [_vm._v("A category association is required")])]) : _vm._e()])]), _vm._v(" "), (!_vm.pricePerOrder) ? _c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-sm-3 pr-0"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Tax")]), _vm._v(" "), (_vm.pricePerPerson.productGenderPriceComponents && _vm.pricePerPerson.productGenderPriceComponents.length > 0) ? _c('input', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.customPerPersonTaxes(_vm.pricePerPerson.productGenderPriceComponents, _vm.pricePerPerson)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.taxes && _vm.pricePerPerson.productGenderPriceComponents && _vm.pricePerPerson.productGenderPriceComponents.length <= 0) ? _c('v-select', {
    attrs: {
      "options": _vm.taxes,
      "label": "description",
      "placeholder": "- Select tax -",
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        return _vm.updateTaxType(_vm.pricePerPerson, _vm.pricePerPerson.vatTypeHelper)
      }
    },
    model: {
      value: (_vm.pricePerPerson.vatTypeHelper),
      callback: function($$v) {
        _vm.$set(_vm.pricePerPerson, "vatTypeHelper", $$v)
      },
      expression: "pricePerPerson.vatTypeHelper"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column pl-3"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Price")]), _vm._v(" "), (_vm.pricePerPerson.productGenderPriceComponents && _vm.pricePerPerson.productGenderPriceComponents.length > 0) ? _c('div', [(_vm.pricePerPerson.componentRuleType == 0) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    staticClass: "glued-right",
    staticStyle: {
      "width": "6rem"
    },
    attrs: {
      "type": "text",
      "disabled": _vm.pricePerPerson.componentRuleType == 0 || _vm.disabled
    },
    domProps: {
      "value": _vm.customPerPersonTotal(_vm.pricePerPerson)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left"
  }, [_vm._v("€")])]) : _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pricePerPerson.value),
      expression: "pricePerPerson.value"
    }],
    staticClass: "glued-right",
    staticStyle: {
      "width": "6rem"
    },
    attrs: {
      "type": "number",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.pricePerPerson.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pricePerPerson, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left"
  }, [_vm._v("€")])])]) : _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pricePerPerson.value),
      expression: "pricePerPerson.value"
    }],
    staticClass: "glued-right",
    staticStyle: {
      "width": "6rem"
    },
    attrs: {
      "type": "number",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.pricePerPerson.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pricePerPerson, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left"
  }, [_vm._v("€")])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex mr-3 flex-grow-1 flex-column"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-2 ml-2"
  }, [_c('div', {
    staticClass: "d-flex mr-2"
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Edit'),
      expression: "'Edit'"
    }],
    staticClass: "fas fa-calculator fs-large medium pointer",
    class: {
      'dark': _vm.hasDecomposedPrices,
      'notAllowed': _vm.disabled && !_vm.hasDecomposedPrices
    },
    on: {
      "click": function($event) {
        return _vm.openEditPrice(_vm.pricePerPerson)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-grow-1"
  }, [(_vm.prices.length > 1) ? _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Dependencies'),
      expression: "'Dependencies'"
    }],
    staticClass: "fas fa-project-diagram fs-large medium pointer",
    class: {
      'color-1': _vm.hasPriceDependencies,
      'notAllowed': _vm.disabled && !_vm.hasPriceDependencies
    },
    on: {
      "click": function($event) {
        return _vm.openGenderPriceDeps(_vm.pricePerPerson)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.showDelete) ? _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Remove'),
      expression: "'Remove'"
    }],
    staticClass: "ico-delete fs-large medium",
    class: {
      'pointer': !_vm.disabled,
      'notAllowed': _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.removePrincingAgeRow(_vm.pricePerPerson)
      }
    }
  }) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4a2cddc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/components/pricingManager/priceRow.vue
// module id = 1370
// module chunks = 0